// extracted by mini-css-extract-plugin
module.exports = {"p_center":"styles_p_center__3EwPd"};